import { HTMLProps } from 'react'

export type MdInlineCodeProps = HTMLProps<HTMLElement>

export const MdInlineCode = ({ children, ...rest }: MdInlineCodeProps) => {
  return <code {...rest}>{children}</code>
}
